import React, { createContext, useState } from 'react';

export const ScrollContext = createContext({
  activeSection: '',
  setActiveSection: () => {}
});

export const ScrollProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState('');
  return (
    <ScrollContext.Provider value={{ activeSection, setActiveSection }}>
      {children}
    </ScrollContext.Provider>
  );
};
